import React from "react";

import { NEW_CONSOLE_URL } from "../utils/constants";

const AboutTextComponent = () => {
  return (
    <div>
      <strong>Objeto:</strong>
      <p>
        Esta aplicación de <strong>Gestión de usuarios web</strong> permite consultar los datos de las cuentas de
        usuario web registradas en la APIv3 de <strong>BRAN</strong> (en los diferentes tenants) y realizar algunas
        acciones administrativas sobre las mismas con el fin de permitir a los agentes diagnosticar problemas y prestar
        soporte a los clientes.
      </p>

      <p>
        Por motivos de seguridad, y para favorecer la autogestión, hay operaciones como la <u>creación de usuarios</u> o
        el
        <u>cambio de contraseña</u> que ya no están disponibles para agentes y son de <u>uso exclusivo del titular</u>{" "}
        legítimo del usuario web. Por lo que NO se pueden ejecutar desde esta consola.
      </p>

      <p>
        Actualmente se gestionan las cuentas de usuario de todas las marcas del norte a excepción de{" "}
        <strong>R: (Telecable, RACCtel+, Euskaltel y Virgintelco)</strong>
      </p>

      <strong>Estado de implantación (agosto 2023):</strong>
      <p>
        Durante los meses de agosto-octubre 2023 las marcas irán migrando sus cuentas de usuario a la APIv3.5, momento
        en el que dejarán de estar disponibles en esta aplicación y pasarán a ser gestionadas desde la nueva{" "}
        <a href={NEW_CONSOLE_URL} target="_blank" rel="noopener noreferrer">
          Consola +BRAN.
        </a>
      </p>

      <p>El orden de migración previsto es:</p>
      <ol>
        <li>
          <p>
            <strong>Racctel+ / MásMóvil B2B / Yoigo B2B</strong> - Fecha 17/agosto/2023
          </p>
        </li>
        <li>
          <p>
            <strong>Telecable</strong> (B2C+B2B)
          </p>
        </li>
        <li>
          <p>
            <strong>Euskaltel</strong> (B2C+B2B)
          </p>
        </li>
        <li>
          <p>
            <strong>VirginTelco</strong> (B2C+B2B)
          </p>
        </li>
        <li>
          <p>
            <strong>R</strong>
          </p>
        </li>
      </ol>
    </div>
  );
};

export default AboutTextComponent;
